module.exports = __webpack_public_path__ + "static/img/index-logo.ba81d0cb.png";